import React, { useState } from "react";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import app, { useFirebaseEmulators } from "../../firebase";

export default function StudentApprovalModal({ student, onClose, onStatusChange, hideChecklist }) {
  const [status, setStatus] = useState(student.appointment.status || "pending");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  // Example fields, replace with actual student fields if available

  const handleApprove = async (approved) => {
    setSubmitting(true);
    setError("");
    try {
      const db = getFirestore(app);
      const studentRef = doc(db, "students", student.id);
      const newStatus = approved ? "approved" : "disapproved";
      await updateDoc(studentRef, {
        "appointment.status": newStatus
      });
      if (!useFirebaseEmulators && (approved === true || approved === false)) {
        const payload = {
          to: student.email,
          name: `${student.lastName}, ${student.firstName}${student.middleName ? ' ' + student.middleName : ''}`,
          idNumber: student.idNumber || '',
          program: student.program || '',
          password: student.password || 'changeme123',
          template: approved ? 'assessmentApproval' : 'assessmentDisapproval'
        };
        if (!payload.to || !payload.name.trim() || !payload.idNumber.trim() || !payload.program.trim() || !payload.password.trim() || !payload.template) {
          setError("Cannot send email: Missing required student information (email, name, ID number, program, password, or template). Please check the student's record.");
          setSubmitting(false);
          return;
        }
        await fetch("https://us-central1-enrollease-19c30.cloudfunctions.net/sendApprovalEmail", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      }
      setStatus(newStatus);
      setSubmitting(false);
      if (onStatusChange) onStatusChange(student, newStatus);
    } catch (err) {
      setError("Failed to update status. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div style={{ background: "#fff", padding: 40, borderRadius: 8, minWidth: 350, maxWidth: 550, boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
        <h3 style={{ marginBottom: 24, color: "#155c2b", fontSize: 20, fontWeight: 700 }}>Student Details</h3>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Name:</b> {student.firstName} {student.middleNameNA ? '' : student.middleName} {student.lastName}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Email:</b> {student.email}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Category:</b> {student.category}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Program:</b> {student.program}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Gender:</b> {student.gender}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Date of Birth:</b> {student.dob}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Mobile:</b> {student.mobile}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>2x2 Picture:</b> {student.picture && <a href={student.picture} target="_blank" rel="noopener noreferrer" style={{ color: "#e67e22", textDecoration: "none" }}>View</a>}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Date of Schedule:</b> {student.appointment.date}</div>
        <div style={{ marginBottom: 12, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Time of Schedule:</b> {student.appointment.time === "am" ? "AM 9:00-12:00" : "PM 1:30-4:30"}</div>
        <div style={{ marginBottom: 20, fontSize: 15 }}><b style={{ color: "#155c2b" }}>Status:</b> <span style={{ color: status === "approved" ? "#27ae60" : status === "disapproved" ? "#e74c3c" : "#f39c12", fontWeight: 600 }}>{status.charAt(0).toUpperCase() + status.slice(1)}</span></div>
        {!hideChecklist && (
          <div style={{ display: "flex", gap: 24, marginBottom: 20 }}>
            <label style={{ fontSize: 15, fontWeight: 500, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}><input type="checkbox" checked={status === "approved"} disabled={submitting} onChange={() => handleApprove(true)} style={{ cursor: "pointer" }} /> <span style={{ color: "#155c2b" }}>Approve</span></label>
            <label style={{ fontSize: 15, fontWeight: 500, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}><input type="checkbox" checked={status === "disapproved"} disabled={submitting} onChange={() => handleApprove(false)} style={{ cursor: "pointer" }} /> <span style={{ color: "#155c2b" }}>Disapprove</span></label>
          </div>
        )}
        {error && <div style={{ color: "#e74c3c", marginBottom: 20, fontSize: 14, fontWeight: 500 }}>{error}</div>}
        <div style={{ display: "flex", justifyContent: "flex-end", borderTop: "1px solid #e0e0e0", paddingTop: 20 }}>
          <button onClick={onClose} style={{ background: "#155c2b", color: "#fff", border: "none", borderRadius: 6, padding: "10px 28px", fontWeight: 600, fontSize: 14, cursor: "pointer", transition: 'background 0.2s' }} onMouseEnter={(e) => e.target.style.background = '#0f4620'} onMouseLeave={(e) => e.target.style.background = '#155c2b'}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}
